/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Invalid_KeyInputs */



/**
* | output |
* | --- |
* | "ElevenLabs rejected your API key. Check the key in Options → Integrations." |
*
* @param {Voice_Manager_Elevenlabs_Invalid_KeyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_invalid_key = /** @type {((inputs?: Voice_Manager_Elevenlabs_Invalid_KeyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Invalid_KeyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ElevenLabs a refusé votre clé API. Vérifiez la clé dans Options → Intégrations.")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs hat Ihren API-Schlüssel abgelehnt. Prüfen Sie den Schlüssel unter Optionen → Integrationen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("ElevenLabs ha rifiutato la tua chiave API. Controlla la chiave in Opzioni → Integrazioni.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ElevenLabs отклонил ваш API-ключ. Проверьте ключ в разделе Параметры → Интеграции.")
	if (locale === "es") return /** @type {LocalizedString} */ ("ElevenLabs rechazó tu clave de API. Revisa la clave en Opciones → Integraciones.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs 拒绝了您的 API 密钥。请在“选项 → 集成”中检查密钥。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs が API キーを拒否しました。オプション → 連携 でキーを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs ने आपकी API कुंजी अस्वीकार कर दी। विकल्प → एकीकरण में कुंजी जाँचें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A ElevenLabs rejeitou a sua chave de API. Verifique a chave em Opções → Integrações.")
	return /** @type {LocalizedString} */ ("ElevenLabs rejected your API key. Check the key in Options → Integrations.")
});